module.exports = __webpack_public_path__ + "img/99.d382b639.jpg";